import { clubbiStyled } from 'clubbi-ui'

export const StyledMain = clubbiStyled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: 'calc(100% + 100px)',
})
